import Email from "@mapmycustomers/shared/types/email/Email";

const isExternalEmail = (email: Email) => {
  return !email.entityId;
};

export default isExternalEmail;
